import React /*useState*/ from 'react';
// import AccountMenu from './AccountMenu';
import { useFrontendConfiguration } from '../components/FrontendConfigurationProvider';
// import { Box, IconButton, Tooltip } from '@mui/material';
// import ChatIcon from '@mui/icons-material/Chat';
// import MicIcon from '@mui/icons-material/Mic';
import './TopBar.scss';
// import CustomDrawer from '../components/widgets/CustomDrawer';
// import ChatWithAgentPopupWidget from '../../web_chat/frontend/ChatWithAgentPopupWidget';
// import VoiceChatWidgetInternal from '@/web_voice/frontend/VoiceChatWidgetInternal';
// import LocalTranslatedText from '@/translation/frontend/components/LocalTranslatedText';
// import { useIsAuthenticated } from '@components/APIProvider';
import { useTopBarState } from '../components/TopBarStateProvider';
import LocalTranslatedText from '@translation/components/LocalTranslatedText';
// import LanguageIcon from '@mui/icons-material/Language';
// import { useTranslationContext } from '../../translation/frontend/components/TranslationProvider';
// import globalTranslationManager from '@/translation/frontend/components/translation_manager';

export default function TopBar() {
  const config = useFrontendConfiguration();
  // const isAuthenticated = useIsAuthenticated();
  // const [openChatDrawer, setOpenChatDrawer] = useState(false);
  // const [openVoiceChatDrawer, setOpenVoiceChatDrawer] = useState(false);
  const { injectedTopBarItems, title, hidden } = useTopBarState();
  // const { showTranslation, toggleTranslation } = useTranslationContext();
  // const shortLang = globalTranslationManager.getLocalLanguageCode();

  // let logoAreaClass = 'logo-area';

  if (hidden) {
    return null;
  }

  return (
    <>
      <div className={'top-bar'} data-testid={'top-bar'}>
        {config ? (
          <>
            <div className="brand-container">
              {/* <div className={logoAreaClass}>
                {config?.frontend?.logo_url !== '' ? (
                  <div className={'logo-image'}>
                    <img
                      src={config?.frontend?.logo_url}
                      alt={config?.frontend?.top_bar_title}
                      className={'logo-image'}
                    />
                  </div>
                ) : null}
                {config?.frontend?.logo_url === '' ? (
                  <span className={'logo-text'}>
                    {config?.frontend?.top_bar_title}
                  </span>
                ) : null}
              </div> */}
              <div className={'page-title-area'}>
                {title ? (
                  <span className={'page-title'}>
                    {typeof title === 'string' ? (
                      <LocalTranslatedText text={title} />
                    ) : (
                      title
                    )}
                  </span>
                ) : null}
                {injectedTopBarItems}
              </div>
            </div>

            {/* <div className="right-container">
              <Tooltip
                title={
                  <LocalTranslatedText
                    text={
                      showTranslation
                        ? 'Show Original (EN)'
                        : `Translate to ${shortLang.toUpperCase()}`
                    }
                  />
                }
              >
                <IconButton
                  variant="contained"
                  size="small"
                  color="info"
                  className="chat-button"
                  onClick={() =>
                    toggleTranslation(showTranslation ? 'en' : shortLang)
                  }
                  data-testid="change-language-button"
                >
                  <LanguageIcon />
                </IconButton>
              </Tooltip>

              {isAuthenticated ? (
                <Tooltip
                  title={<LocalTranslatedText text="Chat with your Agent" />}
                >
                  <IconButton
                    variant="contained"
                    size="small"
                    color="info"
                    className="chat-button"
                    onClick={() => setOpenChatDrawer(true)}
                    data-testid="chat-with-agent-button"
                  >
                    <ChatIcon />
                  </IconButton>
                </Tooltip>
              ) : null}

              {isAuthenticated ? (
                <Tooltip
                  title={<LocalTranslatedText text="Talk with your Agent" />}
                >
                  <IconButton
                    variant="contained"
                    size="small"
                    color="info"
                    className="voice-chat-button"
                    onClick={() => setOpenVoiceChatDrawer(true)}
                    data-testid="talk-with-agent-button"
                  >
                    <MicIcon />
                  </IconButton>
                </Tooltip>
              ) : null}
              <AccountMenu />
            </div> */}
          </>
        ) : null}
      </div>
      {/* {isAuthenticated ? (
        <CustomDrawer
          open={openChatDrawer}
          onClose={() => setOpenChatDrawer(false)}
          title={<LocalTranslatedText text="Chat with your Agent" />}
          data-testid="chat-drawer"
        >
          <ChatWithAgentPopupWidget />
        </CustomDrawer>
      ) : null}
      {isAuthenticated ? (
        <CustomDrawer
          open={openVoiceChatDrawer}
          onClose={() => setOpenVoiceChatDrawer(false)}
          title={<LocalTranslatedText text="Talk with your Agent" />}
          data-testid="voice-chat-drawer"
          width="80vw"
        >
          <Box
            sx={{
              height: '100%',
              width: '100%',
              borderRadius: '16px 0 0 16px',
              overflow: 'hidden',
            }}
          >
            <VoiceChatWidgetInternal />
          </Box>
        </CustomDrawer>
      ) : null} */}
    </>
  );
}
